export type {
  AnchoredRangeResult,
  DocumentRange,
  ElementPosition,
  FlatOffset,
  PmPos,
  PmRangeResult,
  RangeValidation,
  RefreshResult,
  RelativeRange,
  ResolutionMethod,
  SerializedRelPos,
} from "./types.js";

export {
  toFlatOffset,
  toPmPos,
  toSerializedRelPos,
} from "./types.js";
